module.exports = __webpack_public_path__ + "img/4.de594c37.png";